import React from "react";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import FnrButton3 from "UI/FnrButton3";
import FnrModal, { ModalContent } from "UI/FnrModal";

export function ForcePageReloadModal() {
  const { state } = usePaymentPage();
  const { fundColorSafe } = state.fund;

  if (!state.forcePageReload) return null;

  const refreshPage = () => {
    window.location.reload();
  };

  const getContent = () => {
    switch (state.forcePageReload) {
      case "payment_already_processed_on_tab_id":
        return {
          title: "Please check your email for a receipt",
          message:
            "We're sorry, something went wrong in response to your payment attempt. Please check your email for a payment receipt, or contact help@flocknote.com for assistance.",
          buttonText: "Refresh",
        };
      case "authOrUserMismatch":
        return {
          title: "Let's refresh!",
          message:
            "It looks like something may have changed in the background (perhaps you logged in on a different tab). Please refresh the page to make sure everything stays in sync!",
          buttonText: "Refresh",
        };
      default:
        return {
          title: "",
          message: "",
          buttonText: "",
        };
    }
  };

  const content = getContent();

  return (
    <FnrModal show={true}>
      <ModalContent>
        <ContentInner>
          <Title>{content.title}</Title>
          <Body>{content.message}</Body>

          <ButtonWrapper>
            <FnrButton3 onClick={refreshPage} color={fundColorSafe}>
              {content.buttonText}
            </FnrButton3>
          </ButtonWrapper>
        </ContentInner>
      </ModalContent>
    </FnrModal>
  );
}

const ContentInner = styled.div`
  width: 500px;
  max-width: 96%;
  color: #333;
  padding: 20px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 600;
  text-align: center;
`;

const Body = styled.div`
  margin-top: 20px;
  font-weight: 400;
  line-height: 1.4;
`;

const ButtonWrapper = styled.div`
  margin-top: 30px;
  text-align: center;
`;
